import { useQuery } from '@apollo/client'
import { Trans } from '@lingui/react/macro'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import {
  Skeleton,
  Table as TableCortex,
  Td,
  THead,
  TRow,
  useDimensions
} from '@tecsinapse/cortex-react'
import React from 'react'
import { Table } from '@/core/components/index'
import { ULTIMOS_MODIFICADOS_QUERY } from '../data/ultimo-modificados-query'
import { columnsArquivos } from './columns-arquivos'

interface TabelaArquivosProps {
  isRoot: boolean
}

export const TabelaArquivos = ({ isRoot }: TabelaArquivosProps) => {
  const { data, loading } = useQuery(ULTIMOS_MODIFICADOS_QUERY)
  const { ultimosModificados = [] } = data ?? {}

  const { width } = useDimensions()
  const isMobile = width <= 768

  const table = useReactTable({
    data: ultimosModificados ?? [],
    columns: columnsArquivos({ isMobile }),
    getCoreRowModel: getCoreRowModel()
  })

  if (!isRoot || (!loading && (ultimosModificados ?? []).length === 0)) {
    return null
  }

  if (loading) {
    return <Skeleton className='h-28 w-full rounded-mili' />
  }

  return (
    <TableCortex className='w-full mb-deca bg'>
      <THead>
        <TRow>
          <Td colSpan={99} className={'py-centi'}>
            <div
              className={
                'flex w-full flex-row items-center justify-between mb-deca'
              }
            >
              <p className='text-h3 font-bold'>
                <Trans>Arquivos recentes</Trans>
              </p>
            </div>
          </Td>
        </TRow>
      </THead>
      <Table.Body table={table} />
    </TableCortex>
  )
}
